import { render } from "./DetailComponent3Update.vue?vue&type=template&id=70f9b224&scoped=true"
import script from "./DetailComponent3Update.vue?vue&type=script&lang=js"
export * from "./DetailComponent3Update.vue?vue&type=script&lang=js"

import "./DetailComponent3Update.vue?vue&type=style&index=0&id=70f9b224&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70f9b224"]])

export default __exports__